<template>    

    <section class="table pb70">
        <div class="box">

            <div class="table__header">
                <h1>{{title}}</h1>
                <div class="btns">
                    <button class="btn translate-all" :disabled="translatingAll || Object.values(translating).some(v => v)" @click="deeplTranslateAll()" title="Traduci tutto con AI">
                        Traduci tutto con AI
                        <i v-if="translatingAll" class="fal fa-spinner fa-spin"></i>
                    </button>
                </div>
            </div>
            <div class="table__form">

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. title</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['bc_title']">
                                <div class="mt10" style="margin-top: 10px;">
                                    <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_title || translatingAll" @click="deeplTranslate('bc_title', translations[language.id].bc_title)">
                                    <span v-if="!translating.bc_title">Traduci con AI</span>
                                    <span v-else>
                                        <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                    </span>
                                </button>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. description<br>[Tec si - Stat si - Mark si]</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <editor api-key="w9zd7syofrqk6xb3z20cjcd44pj5ryu4jdeg3ecrv568gjdl" :init="{
                                    plugins: ['lists link image paste help wordcount code'],
                                    toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link code'
                                }" v-model="translations[language.id]['bc_msg1']"></editor>
                                    <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_msg1 || translatingAll" @click="deeplTranslate('bc_msg1', translations[language.id].bc_msg1)">
                                        <span v-if="!translating.bc_msg1">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--
                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. description 2</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <editor api-key="w9zd7syofrqk6xb3z20cjcd44pj5ryu4jdeg3ecrv568gjdl" :init="{
                                    plugins: ['lists link image paste help wordcount'],
                                    toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link'
                                }" v-model="translations[language.id]['bc_msg2']"></editor>
                            </div>
                        </div>
                    </div>
                </div>
                -->
                <!--
                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. description 3</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <editor api-key="w9zd7syofrqk6xb3z20cjcd44pj5ryu4jdeg3ecrv568gjdl" :init="{
                                    plugins: ['lists link image paste help wordcount'],
                                    toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link'
                                }" v-model="translations[language.id]['bc_msg3']"></editor>
                            </div>
                        </div>
                    </div>
                </div>
                -->

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. description<br>[Tec si - Stat no - Mark si]</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <editor api-key="w9zd7syofrqk6xb3z20cjcd44pj5ryu4jdeg3ecrv568gjdl" :init="{
                                    plugins: ['lists link image paste help wordcount code'],
                                    toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link code'
                                }" v-model="translations[language.id]['bc_msg4']"></editor>
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_msg4 || translatingAll" @click="deeplTranslate('bc_msg4', translations[language.id].bc_msg4)">
                                        <span v-if="!translating.bc_msg4">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. description<br>[Tec si - Stat si - Mark no]</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <editor api-key="w9zd7syofrqk6xb3z20cjcd44pj5ryu4jdeg3ecrv568gjdl" :init="{
                                    plugins: ['lists link image paste help wordcount code'],
                                    toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link code'
                                }" v-model="translations[language.id]['bc_msg5']"></editor>
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_msg5 || translatingAll" @click="deeplTranslate('bc_msg5', translations[language.id].bc_msg5)">
                                        <span v-if="!translating.bc_msg5">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--
                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. description 6</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <editor api-key="w9zd7syofrqk6xb3z20cjcd44pj5ryu4jdeg3ecrv568gjdl" :init="{
                                    plugins: ['lists link image paste help wordcount'],
                                    toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link'
                                }" v-model="translations[language.id]['bc_msg6']"></editor>
                            </div>
                        </div>
                    </div>
                </div>
                -->
                <!--
                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. description 7</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <editor api-key="w9zd7syofrqk6xb3z20cjcd44pj5ryu4jdeg3ecrv568gjdl" :init="{
                                    plugins: ['lists link image paste help wordcount'],
                                    toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link'
                                }" v-model="translations[language.id]['bc_msg7']"></editor>
                            </div>
                        </div>
                    </div>
                </div>
                -->

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. description<br>[Tec si - Stat no - Mark no]</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <editor api-key="w9zd7syofrqk6xb3z20cjcd44pj5ryu4jdeg3ecrv568gjdl" :init="{
                                    plugins: ['lists link image paste help wordcount code'],
                                    toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link code'
                                }" v-model="translations[language.id]['bc_msg8']"></editor>
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_msg8 || translatingAll" @click="deeplTranslate('bc_msg8', translations[language.id].bc_msg8)">
                                        <span v-if="!translating.bc_msg8">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>







                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. label button</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['bc_show']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_show || translatingAll" @click="deeplTranslate('bc_show', translations[language.id].bc_show)">
                                        <span v-if="!translating.bc_show">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. label button hide</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['bc_hide']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_hide || translatingAll" @click="deeplTranslate('bc_hide', translations[language.id].bc_hide)">
                                        <span v-if="!translating.bc_hide">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. label tab 1</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['bc_tab1']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_tab1 || translatingAll" @click="deeplTranslate('bc_tab1', translations[language.id].bc_tab1)">
                                        <span v-if="!translating.bc_tab1">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. label tab 2</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['bc_tab2']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_tab2 || translatingAll" @click="deeplTranslate('bc_tab2', translations[language.id].bc_tab2)">
                                        <span v-if="!translating.bc_tab2">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. tab 2 message</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <editor api-key="w9zd7syofrqk6xb3z20cjcd44pj5ryu4jdeg3ecrv568gjdl" :init="{
                                    plugins: ['lists link image paste help wordcount code'],
                                    toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link code'
                                }" v-model="translations[language.id]['bc_info']"></editor>
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_info || translatingAll" @click="deeplTranslate('bc_info', translations[language.id].bc_info)">
                                        <span v-if="!translating.bc_info">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. tab 2 message (only booking)</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <editor api-key="w9zd7syofrqk6xb3z20cjcd44pj5ryu4jdeg3ecrv568gjdl" :init="{
                                    plugins: ['lists link image paste help wordcount code'],
                                    toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link code'
                                }" v-model="translations[language.id]['bc_info_only_booking']"></editor>
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_info_only_booking || translatingAll" @click="deeplTranslate('bc_info_only_booking', translations[language.id].bc_info_only_booking)">
                                        <span v-if="!translating.bc_info_only_booking">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. button accept selected</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['bc_btn1']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_btn1 || translatingAll" @click="deeplTranslate('bc_btn1', translations[language.id].bc_btn1)">
                                        <span v-if="!translating.bc_btn1">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. button accept all</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['bc_btn2']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_btn2 || translatingAll" @click="deeplTranslate('bc_btn2', translations[language.id].bc_btn2)">
                                        <span v-if="!translating.bc_btn2">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. button refuses all</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['bc_btn3']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_btn3 || translatingAll" @click="deeplTranslate('bc_btn3', translations[language.id].bc_btn3)">
                                        <span v-if="!translating.bc_btn3">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. table column 1</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['bc_table_column_1']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_table_column_1 || translatingAll" @click="deeplTranslate('bc_table_column_1', translations[language.id].bc_table_column_1)">
                                        <span v-if="!translating.bc_table_column_1">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. table column 2</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['bc_table_column_2']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_table_column_2 || translatingAll" @click="deeplTranslate('bc_table_column_2', translations[language.id].bc_table_column_2)">
                                        <span v-if="!translating.bc_table_column_2">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. table column 3</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['bc_table_column_3']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_table_column_3 || translatingAll" @click="deeplTranslate('bc_table_column_3', translations[language.id].bc_table_column_3)">
                                        <span v-if="!translating.bc_table_column_3">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. table column 4</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['bc_table_column_4']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_table_column_4 || translatingAll" @click="deeplTranslate('bc_table_column_4', translations[language.id].bc_table_column_4)">
                                        <span v-if="!translating.bc_table_column_4">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. table column 5</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['bc_table_column_5']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.bc_table_column_5 || translatingAll" @click="deeplTranslate('bc_table_column_5', translations[language.id].bc_table_column_5)">
                                        <span v-if="!translating.bc_table_column_5">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. no libraries</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['no_libraries']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.no_libraries || translatingAll" @click="deeplTranslate('no_libraries', translations[language.id].no_libraries)">
                                        <span v-if="!translating.no_libraries">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. accetta necessari</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['accetta_necessari']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.accetta_necessari || translatingAll" @click="deeplTranslate('accetta_necessari', translations[language.id].accetta_necessari)">
                                        <span v-if="!translating.accetta_necessari">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">C.b. preferenze gdpr</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['preferenze_gdpr']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.preferenze_gdpr || translatingAll" @click="deeplTranslate('preferenze_gdpr', translations[language.id].preferenze_gdpr)">
                                        <span v-if="!translating.preferenze_gdpr">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">Clicca qui</strong>
                    </div>
                    <div class="translations">
                        <ul class="change-languages">
                            <li  v-for="language in languages" v-bind:key="language.id"  v-on:click="languageSelect(language.slug)" :class="(languageSelected == language.slug) ? 'selected' : ''">
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>
                        <div v-for="language in languages" v-bind:key="language.id" >
                            <div v-if="languageSelected == language.slug && typeof(translations[language.id]) != 'undefined'">
                                <input type="text" v-model="translations[language.id]['click_here']">
                                <div class="mt10" style="margin-top: 10px;">
                                        <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.click_here || translatingAll" @click="deeplTranslate('click_here', translations[language.id].click_here)">
                                        <span v-if="!translating.click_here">Traduci con AI</span>
                                        <span v-else>
                                            <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




                <div class="bcm_action" style="display: flex; justify-content: space-between; align-items: center">

                    <div>
                        <div>
                            <div><strong>Update</strong>: {{ translations.requestLogUpade }}</div>
                        </div>
                    </div>
                    <input type="button" value="Modifica" v-on:click="saveTranslation()">
                </div>
            </div>

        </div>
    </section>

</template>
<script>

    import { mapGetters } from 'vuex'
    import Editor from '@tinymce/tinymce-vue';
    import axios from "axios";
    import langMap from '../../../assets/twocharlanguage.json';
    import flagMixin from '../../../mixins/flagMixin';

    export default {
        mixins: [flagMixin],
        data: () => ({
            title: 'Traduzioni',
            translatingAll: false,
            translating: {
                bc_title: false,
                bc_msg1: false,
                bc_msg4: false,
                bc_msg5: false,
                bc_msg8: false,
                bc_show: false,
                bc_hide: false,
                bc_tab1: false,
                bc_tab2: false,
                bc_info: false,
                bc_info_only_booking: false,
                bc_btn1: false,
                bc_btn2: false,
                bc_btn3: false,
                bc_table_column_1: false,
                bc_table_column_2: false,
                bc_table_column_3: false,
                bc_table_column_4: false,
                bc_table_column_5: false,
                no_libraries: false,
                accetta_necessari: false,
                preferenze_gdpr: false,
                click_here: false
            }
        }),
        components: {
            'editor': Editor // <- Important part
        },
        computed: {

            ...mapGetters(
                {
                    languages: 'translationsModule/languages',
                    languageSelected: 'translationsModule/languageSelected',
                    translations: 'translationsModule/translations'
                }
            ),
            setTitle : function() {
                var ret = {};
                ret.title = "Edit"
                return ret
            },
            languageSelected: {
                set(val){
                    this.$store.state.translationsModule.languageSelected = val
                },
                get(){
                    return this.$store.state.translationsModule.languageSelected
                }
            }

        },

        methods: {
            loadTranslation () {
                this.$store.dispatch('translationsModule/loadTranslation', {urlToConnect: 'translations'})
            },

            languageSelect (slug) {
                this.$store.dispatch('translationsModule/languageSelect', {slug: slug})
            },

            saveTranslation(){

                var parameters = {
                    urlToConnect : 'translations/update',
                    methodToConnect: 'post',
                    _method : "patch",
                    translations: this.$store.state.translationsModule.translations
                }

                this.$store.dispatch('translationsModule/saveTranslation', parameters).then(() => {
                   //NOP
                })

            },

            async deeplTranslate(field, textToTranslate) {
                if (this.translating[field]) return;

                this.$set(this.translating, field, true);

                const selectedLang = this.languageSelected;
                const languageObj = this.languages.find(l => l.slug === selectedLang);
                const sourceLang = langMap[languageObj.slug.toLowerCase()];

                const targetLangs = this.languages
                    .filter(l => {
                        const iso2 = langMap[l.slug.toLowerCase()];
                        return iso2 && iso2 !== sourceLang;
                    })
                    .map(l => langMap[l.slug.toLowerCase()]);

                if (!textToTranslate || !targetLangs.length) {
                    this.$set(this.translating, field, false);
                    return;
                }

                // 🔐 PREPARAZIONE TESTO (HTML SAFE)
                const { text, tokens } = this.prepareForTranslation(textToTranslate);

                try {
                    const payload = {
                        Text: [text],
                        SourceLang: sourceLang,
                        TargetLanguages: targetLangs,
                        Context: 'cookie description'
                    };

                    const response = await axios.post('/deepl-translate', payload);
                    const data = response.data;

                    if (!data.IsSucceded) {
                        throw new Error(data.Errors || 'Errore traduzione');
                    }

                    data.Data.forEach(translation => {
                        if (!translation || !translation.Translations || !translation.Translations.length || !translation.Translations[0]) {
                            return;
                        }

                        const translatedRaw = translation.Translations[0].Text;
                        const langCode = translation.Translations[0].TargetLanguage;

                        if (!translatedRaw || !translatedRaw.trim()) {
                            console.warn('Traduzione vuota per', langCode);
                            return;
                        }

                        const langObj = this.languages.find(l => {
                            if (!l.slug) return false;
                            const iso2 = langMap[l.slug.toLowerCase()];
                            return iso2 && iso2 === langCode;
                        });

                        if (!langObj) return;

                        if (!this.translations[langObj.id]) {
                            this.$set(this.translations, langObj.id, {});
                        }
                        // RIPRISTINO HTML
                        const finalText = this.restoreAfterTranslation(translatedRaw, tokens);

                        this.$set(this.translations[langObj.id], field, finalText);
                    });

                } catch (err) {
                    console.error('Errore durante la traduzione:', err);
                } finally {
                    // levo il flag di traduzione
                    this.$set(this.translating, field, false);
                }
            },

            prepareForTranslation(html) {
                if (!html) return { text: '', tokens: [] };

                const tokens = [];
                let index = 0;

                const tokenize = match => {
                    const key = `[${index}]`;
                    tokens.push({ key, value: match });
                    index++;
                    return key;
                };

                // 🔒 Protegge i placeholder tipo |*LISTA DOMINI*| affinché DeepL non li traduca/alteri
                let text = html.replace(/\|\*.*?\*\|/g, tokenize);

                text = text.replace(/<[^>]+>/g, match => {
                    if (/^<br\s*\/?>$/i.test(match)) {
                        return match;
                    }

                    return tokenize(match);
                });

                return { text, tokens };
            },

            async deeplTranslateAll() {
                if (this.translatingAll) return;
                this.translatingAll = true;

                const itaLang = this.languages.find(l => l.slug === 'ita');
                if (!itaLang || !this.translations[itaLang.id]) {
                    this.translatingAll = false;
                    return;
                }

                const sourceLang = langMap['ita'];

                const fields = Object.keys(this.translating);

                for (const field of fields) {
                    const textToTranslate = this.translations[itaLang.id][field];
                    if (!textToTranslate) {
                        console.warn('[translateAll] SKIP campo', field, '— testo italiano vuoto o mancante');
                        continue;
                    }

                    const targetLangs = this.languages
                        .filter(l => {
                            const iso2 = langMap[l.slug.toLowerCase()];
                            return iso2 && iso2 !== sourceLang;
                        })
                        .map(l => langMap[l.slug.toLowerCase()]);

                    if (!targetLangs.length) {
                        console.warn('[translateAll] SKIP campo', field, '— nessuna lingua target disponibile');
                        continue;
                    }

                    console.log('[translateAll] → campo', field, '| lingue target:', targetLangs);

                    const { text, tokens } = this.prepareForTranslation(textToTranslate);

                    try {
                        const payload = {
                            Text: [text],
                            SourceLang: sourceLang,
                            TargetLanguages: targetLangs,
                            Context: 'cookie description'
                        };

                        const response = await axios.post('/deepl-translate', payload);
                        const data = response.data;

                        if (!data.IsSucceded) {
                            console.error('Errore traduzione campo', field, data.Errors);
                            continue;
                        }

                        data.Data.forEach(translation => {
                            if (!translation || !translation.Translations || !translation.Translations.length || !translation.Translations[0]) return;

                            const translatedRaw = translation.Translations[0].Text;
                            const langCode = translation.Translations[0].TargetLanguage;

                            if (!translatedRaw || !translatedRaw.trim()) return;

                            const langObj = this.languages.find(l => {
                                if (!l.slug) return false;
                                const iso2 = langMap[l.slug.toLowerCase()];
                                return iso2 && iso2 === langCode;
                            });

                            if (!langObj) return;

                            if (!this.translations[langObj.id]) {
                                this.$set(this.translations, langObj.id, {});
                            }

                            const finalText = this.restoreAfterTranslation(translatedRaw, tokens);
                            this.$set(this.translations[langObj.id], field, finalText);
                        });

                    } catch (err) {
                        console.error('Errore durante la traduzione del campo', field, err);
                    }

                    // pausa tra le chiamate per evitare rate limiting sul servizio APIM
                    await new Promise(resolve => setTimeout(resolve, 1000));
                }

                this.translatingAll = false;
            },

            restoreAfterTranslation(translatedText, tokens) {
                let result = translatedText;

                tokens.forEach(t => {
                    result = result.replaceAll(t.key, t.value);
                });

                // normalizza BR duplicati
                result = result.replace(/(<br\s*\/?>\s*){2,}/gi, '<br />');

                return result;
            }

        },
        watch: {
            '$route' () {
                this.loadTranslation()
            }
        },
        created () {
            this.loadTranslation()
        }




    }
</script>